module.exports = __webpack_public_path__ + "static/media/Khuyen Forsythe.45578c40.png";